var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { SimpleApplication } from "@dooboostore/simple-boot";
import { HashRouter, PathRouter, Router } from "@dooboostore/core-web";
import { ElementRouter } from "./router/ElementRouter.js";
import { SimOption } from "@dooboostore/simple-boot";
class SwcAppEngine {
  constructor(host) {
    this.host = host;
    __publicField(this, "simpleApplication");
    __publicField(this, "router");
    __publicField(this, "routerSubscription");
    __publicField(this, "_config");
  }
  get config() {
    return this._config;
  }
  async connect(config) {
    try {
      this._config = config;
      if (this._config.routeType === "path") {
        this.router = new PathRouter({ window: this._config.window, firstUrl: this._config.path });
      } else if (this._config.routeType === "hash") {
        this.router = new HashRouter({ window: this._config.window, firstUrl: this._config.path });
      } else if (this._config.routeType === "element") {
        this.router = new ElementRouter({ window: this._config.window, firstUrl: this._config.path });
      }
      this.simpleApplication = new SimpleApplication(
        new SimOption({
          excludeProxys: [this._config.window.Node],
          container: this._config.container
        })
      );
      const otherInstanceSim = /* @__PURE__ */ new Map();
      this.config?.otherInstanceSim?.forEach((v, k) => {
        otherInstanceSim.set(k, v);
      });
      if (this.router) otherInstanceSim.set(Router, this.router);
      this.simpleApplication.run(otherInstanceSim);
      if (this._config.onStartedLazyDefineComponent) {
        await Promise.all(this._config.onStartedLazyDefineComponent.map((it) => {
          it(this._config.window);
        }));
      }
      if (this._config.onEngineStarted) {
        await this._config.onEngineStarted(this.simpleApplication, this.host);
      }
    } catch (e) {
      console.error("[SWC-APP-ENGINE] Init failed:", e, this._config);
    }
  }
  disconnect() {
    this.routerSubscription?.unsubscribe();
  }
}
export {
  SwcAppEngine
};
//# sourceMappingURL=SwcAppEngine.js.map
